"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleObjectToString = exports.styleObjectToCSSString = exports.selectorGenerator = exports.radioSelectorGenerator = exports.determineBreakPoint = void 0;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var styleObjectToString = function styleObjectToString(styleObject) {
  return Object.entries(styleObject).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        style = _ref2[0],
        value2 = _ref2[1];

    return "".concat(style, ": ").concat(value2);
  }).join(";");
};

exports.styleObjectToString = styleObjectToString;

var styleObjectToCSSString = function styleObjectToCSSString(selector, styleObject) {
  return "".concat(selector, " {\n    ").concat(styleObjectToString(styleObject), "\n  }");
};

exports.styleObjectToCSSString = styleObjectToCSSString;

var selectorGenerator = function selectorGenerator(key, className) {
  switch (key) {
    case "unselected":
      {
        return className;
      }

    case "selected":
      {
        return "".concat(className, ":active");
      }

    case "disabled":
      {
        return "".concat(className, ":disabled");
      }

    default:
      return "";
  }
};

exports.selectorGenerator = selectorGenerator;

var radioSelectorGenerator = function radioSelectorGenerator(key, className) {
  switch (key) {
    case "unselected":
      {
        return className;
      }

    case "selected":
      {
        return "".concat(className, ":checked");
      }

    case "disabled":
      {
        return "".concat(className, ":disabled");
      }

    default:
      return "";
  }
};

exports.radioSelectorGenerator = radioSelectorGenerator;

var determineBreakPoint = function determineBreakPoint(width) {
  var breakPoints = [{
    width: 48,
    name: "sm"
  }, {
    width: 60,
    name: "md"
  }, {
    width: 72,
    name: "lg"
  }, {
    width: 84,
    name: "xl"
  }, {
    width: 96,
    name: "xxl"
  }];
  var widthAsEm = width / 16;
  return breakPoints.reduce(function (accu, i) {
    return widthAsEm < i.width ? accu : i;
  }, {
    width: 0,
    name: "xs"
  });
}; // const radioSelectorGenerator = (key, className) => {
//     switch (key) {
//         case 'unselected': {
//             return className;
//         }
//         case 'selected': {
//             return `${className}:checked`;
//         }
//         case 'disabled': {
//             return `${className}:disabled`;
//         }
//         default: return '';
//     }
// };
// const emptyObject = obj => Object.entries(obj).length === 0;
// export {
//     styleObjectToString,
//     styleObjectToCSSString,
//     selectorGenerator,
//     radioSelectorGenerator,
//     // radioBtnSelectorGenerator,
//     // emptyObject,
// };
// export default {
//     styleObjectToString,
//     styleObjectToCSSString,
//     selectorGenerator,
//     radioSelectorGenerator,
//     // radioBtnSelectorGenerator,
//     // emptyObject,
// };


exports.determineBreakPoint = determineBreakPoint;